// extracted by mini-css-extract-plugin
export default {"modalApplicantDetail":"style_modalApplicantDetail__+BQvz","applicantWrapper":"style_applicantWrapper__4UX68","videoContainer":"style_videoContainer__0qZmd"};